import { namespace } from 'vuex-class';

export const participantVuexNamespace = namespace('participant/');
